// extracted by mini-css-extract-plugin
module.exports = {"listContent":"all-external-assessments_listContent__3vmBW","mainTitle":"all-external-assessments_mainTitle__1pZJm"};